module.exports = __webpack_public_path__ + "static/media/girl_pointing_ring.7bc54744.png";